<ng-container *transloco="let t">
  <div class="certificate-form">
    <label class="section-label">{{ t('Injuries or biting') }}</label>
    <mat-form-field appearance="outline" class="full">
      <textarea matInput rows="4" [formControl]="injuriesDetails"></textarea>
    </mat-form-field>

    <div class="exam-row">
      <div class="exam-item">
        <label class="section-label">{{
          t('This animal was clinically examined on')
        }}</label>
        <mat-form-field appearance="outline" class="full">
          <input
            matInput
            [matDatepicker]="picker1"
            [formControl]="exam1Date"
            placeholder="dan/mesec/godina"
          
          [min]="minDate" [max]="today"
        />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker1"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline" class="full">
          <mat-label>{{
            t('Does not show / shows clinical symptoms of rabies')
          }}</mat-label>
          <textarea matInput rows="3" [formControl]="exam1Findings"></textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="full">
          <mat-label>{{ t('Veterinarian') }}</mat-label>
          <input matInput [formControl]="exam1Veterinarian" />
        </mat-form-field>
      </div>
    </div>

    <div class="exam-row">
      <div class="exam-item">
        <label class="section-label">{{
          t('This animal was clinically examined on')
        }}</label>
        <mat-form-field appearance="outline" class="full">
          <input
            matInput
            [matDatepicker]="picker2"
            [formControl]="exam2Date"
            placeholder="dan/mesec/godina"
          
          [min]="minDate" [max]="today"
        />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker2"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline" class="full">
          <mat-label>{{
            t('Does not show / shows clinical symptoms of rabies')
          }}</mat-label>
          <textarea matInput rows="3" [formControl]="exam2Findings"></textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="full">
          <mat-label>{{ t('Veterinarian') }}</mat-label>
          <input matInput [formControl]="exam2Veterinarian" />
        </mat-form-field>
      </div>
    </div>

    <div class="exam-row">
      <div class="exam-item">
        <label class="section-label">{{
          t('This animal was clinically examined on')
        }}</label>
        <mat-form-field appearance="outline" class="full">
          <input
            matInput
            [matDatepicker]="picker3"
            [formControl]="exam3Date"
            placeholder="dan/mesec/godina"
          
          [min]="minDate" [max]="today"
        />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker3"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker3></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline" class="full">
          <mat-label>{{
            t('Does not show / shows clinical symptoms of rabies')
          }}</mat-label>
          <textarea matInput rows="3" [formControl]="exam3Findings"></textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="full">
          <mat-label>{{ t('Veterinarian') }}</mat-label>
          <input matInput [formControl]="exam3Veterinarian" />
        </mat-form-field>
      </div>
    </div>

    <label class="section-label">{{ t('Notes') }}</label>
    <mat-form-field appearance="outline" class="full">
      <textarea matInput rows="3" [formControl]="notes"></textarea>
    </mat-form-field>

    <label class="section-label">{{ t('Veterinarian') }}</label>
    <mat-form-field appearance="outline" class="full">
      <input matInput [formControl]="veterinarianName" required />
    </mat-form-field>
  </div>
</ng-container>
